// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-network{display:flex}.referral-network span{padding-right:10px}.referral-service-type{display:flex;justify-content:space-between}.consent-reminder{margin-top:15px}", ""]);
// Exports
module.exports = exports;
